import React, { Component } from "react";
import { Select } from "antd";
import axios from "axios";

const { Option } = Select;

class SelectSubProyectosItem extends Component {
  state = { opciones: [], cargando: false };

  componentDidMount() {
    this.cargarSubProyectos();
  }

  cargarSubProyectos = () => {
    this.setState({ cargando: true });
    axios
      .post("subProyectos/selectSubProyectos", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ cargando: false });
        if (res.data.success === 2) this.setState({ opciones: res.data.subProyectos || [] });
      })
      .catch(() => this.setState({ cargando: false }));
  };

  render() {
    const { empresaId, headersToken, ...rest } = this.props;
    return (
      <Select loading={this.state.cargando} showSearch optionFilterProp="children" allowClear {...rest}>
        {this.state.opciones.map((subProyecto) => (
          <Option key={subProyecto._id} value={subProyecto._id}>
            {subProyecto.codigo} - {subProyecto.nombre}
          </Option>
        ))}
      </Select>
    );
  }
}

export default SelectSubProyectosItem;
